import { Route, Routes } from "react-router-dom";
import Background from "./components/Background";
import StickyHeader from "./components/StickyHeader";
import ThemeToggle from "./components/ThemeToggle";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

export default function App() {
    return (
        <>
            <Background />
            <StickyHeader />
            <ThemeToggle />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </>
    );
}
